export default {
  path: '/lvy-authorize-profile',
  component: () => import('./LVYAuthorizeProfile'),
  meta: {
    title: '青藤之恋个人信息授权协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}